/* T8 UGC rail: autoplay muted loop videos while visible; + chip quick-adds the tagged product */
(function () {
  'use strict';
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting && en.intersectionRatio > .4) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: [0, .4, .8] }) : null;

  function addToCart(id) {
    if (window.TamyraCart && window.TamyraCart.add) return window.TamyraCart.add([{ id: id, quantity: 1 }]);
    if (window.T8Cart && window.T8Cart.add) return window.T8Cart.add(id, 1);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('Cart error'); return r.json(); })
      .then(function (d) { document.dispatchEvent(new CustomEvent('tamyra:cart:updated', { detail: { added: d } })); return d; });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-t8-ugc-video], .t8-ugc__video').forEach(function (v) {
      if (v.dataset.ready) return; v.dataset.ready = '1';
      v.muted = true; v.loop = true; v.setAttribute('playsinline', '');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { v.preload = 'metadata'; return; }
      if (io) io.observe(v); else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
    (root || document).querySelectorAll('[data-t8-ugc-add]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = '1';
      function go(e) {
        var id = Number(b.dataset.t8UgcAdd); if (!id) return; // no variant: let the chip link through to the product
        e.preventDefault(); e.stopPropagation();
        addToCart(id).then(function () { b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); }, 1600); }, function () {});
      }
      b.addEventListener('click', go);
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
    });
  }
  /* phones: coverflow — the card nearest the rail's centre gets .is-centre (full size); the others shrink (CSS) */
  function coverflow(root) {
    (root || document).querySelectorAll('.t8-ugc__rail').forEach(function (rail) {
      if (rail.dataset.cf) return; rail.dataset.cf = '1';
      var raf = 0;
      function mark() {
        raf = 0;
        var mid = rail.scrollLeft + rail.clientWidth / 2, best = null, bd = Infinity;
        Array.prototype.forEach.call(rail.children, function (c) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = c; } });
        Array.prototype.forEach.call(rail.children, function (c) { c.classList.toggle('is-centre', c === best); });
      }
      rail.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(mark); }, { passive: true });
      window.addEventListener('resize', mark);
      var second = rail.children[1];
      if (second && rail.children.length > 2 && window.matchMedia('(max-width: 640px)').matches) {   /* start on the 2nd card so a neighbour peeks on both sides (Figma) */
        rail.scrollLeft = second.offsetLeft + second.offsetWidth / 2 - rail.clientWidth / 2;
      }
      mark();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { coverflow(document); }); else coverflow(document);
  document.addEventListener('shopify:section:load', function (e) { coverflow(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
